import { render, staticRenderFns } from "./SmartPNHistory.vue?vue&type=template&id=6b5b9c56&scoped=true"
import script from "./SmartPNHistory.vue?vue&type=script&lang=ts"
export * from "./SmartPNHistory.vue?vue&type=script&lang=ts"
import style0 from "./SmartPNHistory.vue?vue&type=style&index=0&id=6b5b9c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b9c56",
  null
  
)

export default component.exports